module.exports = __webpack_public_path__ + "img/founder.ff85dc37.svg";